import { Provider } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

/**
 * Creates a mock DialogRef provider with realistic defaults.
 * All methods are functional no-ops suitable for Storybook.
 *
 * @returns Provider configuration for DialogRef
 *
 * @example
 * ```typescript
 * // Basic usage
 * providers: [MockDialogRef()]
 * ```
 */
export function MockDialogRef(): Provider {
  return {
    provide: DialogRef,
    useValue: {
      close: (): void => undefined,
    } as Partial<DialogRef>,
  };
}
